import Vue from 'vue'

import ModalAlertContainer from '@/components/modalAlertContainer'
import ModalContainer from '@/components/modalContainer'

import AddressModal from '@/components/pages/addressModal'
import LayoutHeader from '@/components/pages/layoutHeader'
import LayoutFooter from '@/components/pages/layoutFooter'
import TermsService from '@/components/pages/termsService'
import TermsPrivacy from '@/components/pages/termsPrivacy'

Vue.component(ModalAlertContainer.name, ModalAlertContainer)
Vue.component(ModalContainer.name, ModalContainer)

Vue.component(AddressModal.name, AddressModal)
Vue.component(LayoutHeader.name, LayoutHeader)
Vue.component(LayoutFooter.name, LayoutFooter)
Vue.component(TermsService.name, TermsService)
Vue.component(TermsPrivacy.name, TermsPrivacy)
